module.exports = __webpack_public_path__ + "img/hr-dead-grey-trunk-05.4266cc96.png";